<template>
  <div class="haircut">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h1 class="hair-cut-head">{{ service.title }}</h1>

          <div>
            <h4 class="text-white">Estimated Service Time: {{ estimated_time }}</h4>
          </div>

          <!-- <div class="hair-cut-time pt-4">
            <h2 class="text-white m-0">Estimated Time:</h2>
            <div class="time">{{ service.time_period }}</div>
            <div class="time-instance">Minutes</div>
          </div> -->

          <div class="py-2 text-center selected-service">
            <span class="question px-4 py-2">Would You Like To Proceed?</span>
          </div>
          <div class="buttons pt-5 d-flex justify-content-between">
            <router-link class="text-decoration-none" to="/"
              ><button class="btn cancel-btn">Cancel</button></router-link
            >
            <router-link
              class="text-decoration none"
              :to="{
                name: `Remainder`,
                params: {
                  slug: service.slug,
                },
              }"
              ><button class="btn submit-btn">Continue</button></router-link
            >
          </div>
        </div>
        <!-- <div class="col-md-6">
          <div class="hair-cut-img">
            <img src="@/assets/Frame.png" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "SelectedService",

  data() {
    return {
      service: {},
      estimated_time: "",
      // isLoading: true,
    };
  },
  mounted() {
    this.getEstimatedTime();
    this.isLoading(true);
    if (this.$route.params.slug) {
      this.getSingleServiceDetail();
    } else {
      this.$$router.push("/");
    }
  },
  methods: {
    getEstimatedTime() {
      this.$http.get("/get-start-time").then((res) => {
        this.estimated_time = res.data.data;
        console.log(this.estimated_time);
        this.isLoading(false);
      });
    },
    getSingleServiceDetail() {
      this.$http.get(`/service/${this.$route.params.slug}`).then((res) => {
        if (res.data.status == 1) {
          this.service = res.data;
          this.isLoading(false);
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
        }
      });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
  },
};
</script>
